import type { SketchfabConfig } from '#types/config/components/sketchfab'
import type { RecursivePartial } from '#types/utils'

export default {
  autoplay: false,
  icon: {
    src: 'https://assets.timberland.eu/image/upload/v1748261027/3d-icon.svg',
    width: 12,
    height: 12,
  },
  products: {
    TB110061713: '320b7aa55a4e459f9d20855db793b32d',
    TB0A69UHEM6: '4fcb5a9edb9147c3b8b1061d4e748eac',
    TB0A6A4WEM5: '1042546505eb43f780418307b4340da4',
    TB0A6A4WEM6: '16b63a121d14410f85bcb0af7ccc852e',
    TB127094214: '0f6c2ba541f64cfb8c44e0fe6637912e',
    TB030003214: 'a99b2c3555ae475fbc754b619b3f9139',
    TB127097214: '053f3ab581684ec0a4490150681b89ea',
    TB0A6A4WW02: 'fcc0824dc8644ea1a1c13027c65a7d65',
    TB0A69UHW02: '5c7e497bbe2c4c73ae68c0b98648f471',
    TB0A5S5M015: '61d2faa54f254f1587d36eeafe9cbbd2',
    TB0A6A8NW07: '57ea6e4f203e41249c5ce82da8934f66',
    TB110361713: '7e1f3e4916bd4e1184edb14f479eddc8',
    TB0A5ND7015: '4f3956596f9f4584ad5a0b01c848371d',
    TB0A2FT6EM5: '0a5323c3c25648b996d6699092df600b',
    TB0A5ZCG001: '3803a2b690a74b0cbcee4b83e2db48ef',
    TB0A5RNG001: '8357b244f0c8406dae4732e3f91b3a06',
    TB1A19TE231: '1803caf060414fe19619d9a799571795',
    TB0A5RPR032: '86cedb78a02c47d385e996f636e5a448',
    TB0A2QDMD57: 'a507a8a7cdd2477a801b4170ff7c5145',
    TB010360214: '10316ad321bd4cbea2ebfbe0cc5b41df',
    TB0A28U8W02: 'c1e37b4ac1074367bb26f760b3c55999',
    TB08658A001: '7a281691b1664474aedfde5badd91078',
    TB0A2PBBW02: '882bc09cd6d9426a9a4334410e452cf4',
    TB0A2P6WA4E: 'f34a63559d0e4446a788ff7ab842cb62',
    TB0A2P6WA4J: '8dcbddcdc564441a818158000353252d',
    TB0A2PDQEM4: '4b686445510347e6a138cf4318c5648e',
    TB0A2P6WEQ3: 'e94926e1327a413d85c78ed5d73fd4c0',
    TB0A2P6WEEQ: '506506cb0c11491291f8053424ceafef',
    TB0A2PDQA3L: '937098d752874cfbac8aa7d63456de54',
    TB0A2P6WA5D: '5af19a5fe09640e48d8c950773152eae',
    TB0A2GNVEM5: '0bd766818e2d434e9195cef510baf53e',
    TB0A2P6WEN2: 'bad833a914004350a42ff30359652d85',
    TB0A4188EL6: '8afd5a9a7dbf4c57a859c70bb2c15dc1',
    TB0A4188EIW: 'e70e83ce31114a858bdf64c38d2970a4',
    TB0A2GNVEN2: '6707ae038d0b42fe87bd79aacaa18cd5',
    TB0A2PDQEN2: 'dc1ac4f6c7ff4d6590444e94ebefc817'
  }
} satisfies RecursivePartial<SketchfabConfig>
